import { useState } from 'react';
import useUserContext from './useUserContext';
import { Comment } from '../types';

/**
 * Custom hook that handles the comment section of the answer page.
 * @param handleAddComment Function to handle the addition of a new comment.
 * @returns An object containing the state variables and functions for the comment section.
 */
const useCommentSection = (handleAddComment: (comment: Comment) => void) => {
  const { user } = useUserContext();
  const [text, setText] = useState<string>('');
  const [textErr, setTextErr] = useState<string>('');
  const [showComments, setShowComments] = useState<boolean>(false);

  /**
   * Function to handle the addition of a new comment.
   */
  const handleAddCommentClick = () => {
    if (text.trim() === '' || user.username.trim() === '') {
      setTextErr(text.trim() === '' ? 'Comment text cannot be empty' : '');
      return;
    }

    const newComment: Comment = {
      text,
      commentByUser: user,
      commentDateTime: new Date(),
    };

    handleAddComment(newComment);
    setText('');
    setTextErr('');
  };

  return {
    showComments,
    setShowComments,
    text,
    setText,
    textErr,
    handleAddCommentClick,
  };
};

export default useCommentSection;
